import React from 'react';
import { TestimonialCard } from './TestimonialCard';
export function Feedback() {
  const testimonials = [{
    quote: "I've been importing from Lux Hair for 3 years. The consistency of their bone straight hair is unmatched. My customers in Atlanta love it.",
    author: 'Sarah Johnson',
    role: 'Owner',
    company: 'Royal Tresses Boutique (USA)',
    imageUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=1888&auto=format&fit=crop'
  }, {
    quote: 'Finally a factory that understands quality control. No shedding, true to length, and the double drawn bundles are actually full from top to bottom.',
    author: 'Amara Okeke',
    role: 'Distributor',
    company: 'Lagos Beauty Supply (Nigeria)',
    imageUrl: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=80&w=1887&auto=format&fit=crop'
  }, {
    quote: 'Their shipping speed is impressive. I get my bulk orders in London within 5 days. Great communication via WhatsApp throughout the process.',
    author: 'Elena Rossi',
    role: 'Founder',
    company: 'Bella Hair Extensions (UK)',
    imageUrl: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=1961&auto=format&fit=crop'
  }];
  return <section className="py-20 bg-white" data-id="element-126">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
        <div className="text-center mb-16" data-id="element-128">
          <h2 className="text-[#d4af37] font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-129">
            Client Feedback
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-130">
            Trusted by Global Hair Brands
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-131">
          {testimonials.map((testimonial, index) => <TestimonialCard key={index} quote={testimonial.quote} author={testimonial.author} role={testimonial.role} company={testimonial.company} imageUrl={testimonial.imageUrl} data-id="element-132" />)}
        </div>
      </div>
    </section>;
}